import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Set a value in localStorage (web) or Capacitor Preferences (native)
 * @param {string} key - Key name
 * @param {string} value - Value to store
 */
export async function setItem(key, value) {
    const isNative = Capacitor.isNativePlatform();
    if (isNative) {
        await Preferences.set({ key, value });
    } else {
        localStorage.setItem(key, value);
    }
}

/**
 * Get a value from localStorage (web) or Capacitor Preferences (native)
 * @param {string} key - Key name
 * @returns {Promise<string|null>} - The stored value or null if not found
 */
export async function getItem(key) {
    const isNative = Capacitor.isNativePlatform();
    if (isNative) {
        const { value } = await Preferences.get({ key });
        return value;
    } else {
        return localStorage.getItem(key);
    }
}
/**
 * Remove a value from localStorage (web) or Capacitor Preferences (native)
 * @param {string} key - Key name
 */
export async function removeItem(key) {
    const isNative = Capacitor.isNativePlatform();
    if (isNative) {
        await Preferences.remove({ key });
    } else {
        localStorage.removeItem(key);
    }
}

export async function clear() {
    const isNative = Capacitor.isNativePlatform();
    if (isNative) {
        await Preferences.clear();
    } else {
        localStorage.clear();
    }
}